// This is a test channel.
// TODO psfp : Seems liks this is only used when queueing, check and make necessary changes
$(document).ready(() => {
  var container = $('#projectWaitingList')
  if (container.length <= 0) { return; }

  subscribeToSubscriptionValidationChannel(container);
});

function subscribeToSubscriptionValidationChannel(container) {
  App.cable.subscriptions.create(
    {
      channel: 'SubscriptionValidationChannel',
      subscription_id: container.data('subscription-id'),
    },
    {
      received(data) {
        if (!!data['failure_path']) {
          window.location.replace(data['failure_path']);
        } else {
          $('#finalizeSubscriptionButton').attr('href', data['next_step_path']);
          $('#cancelSubscriptionButton').attr('href', data['cancelation_path']);

          // Checking if we are using the new design
          if (document.getElementById('subscriptionValidated')) {
            $('#projectWaitingList').addClass('d-none');
            $('#subscriptionValidated').removeClass('d-none');
            const investBtn = document.getElementById('investBtn');
            investBtn.innerText = investBtn.dataset.nextText;
          } else {
            const subscriptionValidatedModal = new bootstrap.Modal(
              '#subscriptionValidatedModal',
              {
                backdrop: 'static',
                keyboard: false
              }
            );
            subscriptionValidatedModal.show();
          }

          this.unsubscribe();
        }
      }
    }
  )
};

// Expose top-level declarations as globals (pre-bundler concatenation behavior).
window.subscribeToSubscriptionValidationChannel = subscribeToSubscriptionValidationChannel;
